import { connect } from "@fireproof/partykit";
import { Database, fireproof } from "use-fireproof";
import { authProvider } from "./auth";

interface DbProvider {
  db: () => Promise<Database>;
}

export const dbProvider: DbProvider = {
  db: async () => {
    let database = fireproof("checks");
    const user = await authProvider.user();
    if (user?.subscription?.status == 'active') {
      const connection = connect.partykit(
        { name: user.id, blockstore: database.blockstore },
        import.meta.env.VITE_PARTYKIT_HOST
      );

      connection.party.updateProperties({
        query: () => ({ token: authProvider.hanko().getSessionToken() }),
      });

      connection.dataUpload = async (bytes: Uint8Array, params: any) => {
        const jwt = authProvider.hanko().getSessionToken();
        const url = `${connection.host}/parties/fireproof/${connection.name}?car=${params.car}`;
        const response = await fetch(url, { method: "PUT", body: bytes, headers: { Authorization: `Bearer ${jwt}` } });
        if (response.status === 404) {
          throw new Error("Failure in uploading data!");
        }
      };

      connection.dataDownload = async (params: any) => {
        const jwt = authProvider.hanko().getSessionToken();
        const url = `${connection.host}/parties/fireproof/${connection.name}?car=${params.car}`;
        const response = await fetch(url, { method: "GET", headers: { Authorization: `Bearer ${jwt}` } });
        if (response.status === 404) {
          throw new Error("Failure in downloading data!");
        }
        const data = await response.arrayBuffer();
        return new Uint8Array(data);
      };
    } else {
      console.log("initializing db without user");
    }
    return database;
  },
};

export async function resolveLastCheckNumber(db, account) {
  if (account.lastCheckNumber) return account.lastCheckNumber;

  const checks = (await db.query("type", { key: "check" })).rows;
  const matching = checks
    .map((r) => r.doc)
    .filter(
      (c) =>
        c.checkNumber &&
        c.accountNumber === account.accountNumber &&
        c.routingNumber === account.routingNumber
    );
  const lastCheckNumber =
    matching.length > 0
      ? Math.max(...matching.map((c) => c.checkNumber))
      : (account.checkNumber || 500) - 1;

  account.lastCheckNumber = parseInt(lastCheckNumber);
  await db.put(account);
  return account.lastCheckNumber;
}

export default dbProvider;
